import { useMemo } from "react";

import {
  COMPUTED_VALUE,
  EMPTY_VALUE,
  WRITE_ONLY_VALUE,
} from "components/Environment/constants/values";
import CodeSnippetInline from "ds/components/CodeSnippetInline";
import makeUseCellCopyAction from "ds/components/Table/helpers/makeUseCellCopyAction";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const useCellCopyAction = makeUseCellCopyAction();

const ValueCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const { runtime, writeOnly, value } = item.element;
  const isPlainValue = !runtime && !writeOnly && !!value;

  const copyAction = useCellCopyAction({ text: value || "" });
  const actions = useMemo(() => (isPlainValue ? [copyAction] : []), [copyAction, isPlainValue]);

  let displayValue = EMPTY_VALUE;
  if (runtime) {
    displayValue = COMPUTED_VALUE;
  } else if (writeOnly) {
    displayValue = WRITE_ONLY_VALUE;
  } else if (value) {
    displayValue = value;
  }

  return (
    <EnvironmentTableCell {...cellProps} actions={actions}>
      <CodeSnippetInline>{displayValue}</CodeSnippetInline>
    </EnvironmentTableCell>
  );
};

export default ValueCell;
